import { render, staticRenderFns } from "./Gallery2.vue?vue&type=template&id=a4e1ca98&"
import script from "./Gallery2.vue?vue&type=script&lang=js&"
export * from "./Gallery2.vue?vue&type=script&lang=js&"
import style0 from "./Gallery2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports